import { Menu, Plus, Search } from 'lucide-react'
import { useWorkspace } from '@/providers/workspace-provider'
import { useTaskActions } from '@/features/tasks/task-actions'
import { Button } from '@/components/ui/button'
import { ThemeToggle } from './theme-toggle'
import { NotificationsMenu } from './notifications-menu'

export function Topbar({
  onOpenMobileNav,
  onOpenPalette,
}: {
  onOpenMobileNav: () => void
  onOpenPalette: () => void
}) {
  const { can } = useWorkspace()
  const { openCreate } = useTaskActions()

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-2 border-b border-border/60 bg-background/70 px-4 backdrop-blur-glass sm:px-6">
      <Button
        variant="ghost"
        size="icon"
        className="lg:hidden"
        onClick={onOpenMobileNav}
        aria-label="Menu"
      >
        <Menu className="h-5 w-5" />
      </Button>

      <button
        onClick={onOpenPalette}
        className="flex h-9 flex-1 items-center gap-2 rounded-xl border border-input bg-background/60 px-3 text-sm text-muted-foreground backdrop-blur-sm transition-colors hover:bg-accent/40 sm:max-w-xs"
      >
        <Search className="h-4 w-4" />
        <span className="flex-1 text-left">Buscar…</span>
        <kbd className="hidden rounded border border-border px-1.5 text-[10px] sm:inline">
          Ctrl K
        </kbd>
      </button>

      <div className="flex-1" />

      {can.write && (
        <Button onClick={() => openCreate()} className="hidden sm:flex">
          <Plus className="h-4 w-4" /> Nova tarefa
        </Button>
      )}
      {can.write && (
        <Button
          onClick={() => openCreate()}
          size="icon"
          className="sm:hidden"
          aria-label="Nova tarefa"
        >
          <Plus className="h-5 w-5" />
        </Button>
      )}

      <NotificationsMenu />
      <ThemeToggle />
    </header>
  )
}
